import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ELacProcessTypes } from 'src/app/domain/Lac - EAU/enum/lac-process-types';
import { MesurePhysique } from 'src/app/domain/Lac - EAU/mesure-physique';
import { InterventionService } from 'src/app/services/intervention.services';
import { NotificationManager } from '../../notification-manager';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StringConverter } from '../string-converter';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { SimpleListModel } from 'src/app/models/simple-list-model';
import { InterventionCreateDTO } from 'src/app/services/DTO/intervention.dto';
import { EGroupementPrelevementAnalyse } from 'src/app/domain/Shared/enum/groupement-prelevement-analyse';
import { UserService } from 'src/app/services/user-service';
import { User } from 'src/app/domain/planning/user';
import { Intervention } from 'src/app/domain/planning/intervention';

@Component({
    selector: 'app-intervention-creation-box',
    templateUrl: './intervention-creation-box.component.html',
    styleUrls: ['./intervention-creation-box.component.scss']
})
export class InterventionCreationBoxComponent implements OnInit {

    public InterventionTypeList: SimpleListModel[] =
        Object.values(EInterventionType)
            .filter(x => !isNaN(Number(x)) && x !== EInterventionType.Cyano && x !== EInterventionType.LAC)
            .map((x: EInterventionType) => {
                const slm = new SimpleListModel();
                slm.idx = x as number;
                slm.s = StringConverter.getInterventionTypeName(x as EInterventionType);
                return slm;
            });

    public GroupementAnalyseList: SimpleListModel[] =
        Object.values(EGroupementPrelevementAnalyse)
            .filter(x => !isNaN(Number(x)))
            .map((x: EGroupementPrelevementAnalyse) => {
                const slm = new SimpleListModel();
                slm.idx = x as number;
                slm.s = StringConverter.getGroupementAnalyseName(x as EGroupementPrelevementAnalyse);
                return slm;
            });
    Model: InterventionCreateDTO = new InterventionCreateDTO()
    public AllUserList: User[] = [];

    constructor(
        private dialogRef: MatDialogRef<InterventionCreationBoxComponent>,
        private interventionService: InterventionService,
        private userService: UserService,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data) {

    }

    ngOnInit(): void {
        this.getAvailableUserList();
    }

    CanAddNewMeasure() {
        return this.Model.SamplerPuid && this.Model.SamplerPuid !== ''
            && this.Model.StationName && this.Model.StationName !== ''
            && this.Model.ResponsiblePuid && this.Model.ResponsiblePuid !== ''
            && this.Model.Type && this.Model.GroupementAnalyse;
    }

    compareUser(u1: User, u2: User): boolean {
        return u1?.Code === u2?.Code;
    }

    getAvailableUserList() {
        this.userService.getAll().subscribe(x => this.AllUserList = x);
    }

    createNewIntervention() {

    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm() {
        this.interventionService.createIntervention(this.Model).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Intervention créée', this.snackBar);
                this.dialogRef.close(x);
            }
        })
    }
}
